import React from "react";
import { dentalIcons } from "../../dentail-indetifcation/utils-icons/dentalIcons";
import CustomPrimaryButton from "../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import CustomButtonWithIcon from "../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";
import CustomDeleteButton from "../../dentail-indetifcation/components/d-reusable/CustomDeleteButton";

const FlipImageWarming = ({ isVisible, onYes, onCancel }) => {
  if (!isVisible) return;
  return (
    <div
      className="absolute top-[30%] left-4 h-[200px] bg-white rounded-[12px] w-[298px]"
      style={{
        background:
          "linear-gradient(182deg, rgba(32, 195, 255, 0.08) 9.71%, rgba(255, 254, 254, 0.00) 64.83%), #FFF",
        boxShadow:
          "0 3px 2px 0 rgba(14, 18, 27, 0.04), 0 4px 12px 0 rgba(14, 18, 27, 0.10)",
      }}
    >
      <div className="image_analysis_container p-[12px]">
        <div className="flex items-center">
          <div className="flex items-center gap-2">
            <img src={dentalIcons.rotationIcon} alt="rotation" />
            <p className="text-[16px] text-[#000000] font-semibold">Warning</p>
          </div>

          <div
            className="absolute right-4 top-4 cursor-pointer"
            onClick={onCancel}
          >
            <img src={dentalIcons.crossIcon} alt="cross" />
          </div>
        </div>
        <div className="px-1 py-2">
          <p className="text-[#7B7878] font-medium text-[15px]">
            Fliping image will remove your current drawings and measurements. Do
            you want to continue?
          </p>
        </div>
        <div className="px-1 py-2 flex gap-2">
          <CustomButtonWithIcon
            title="No"
            isRound
            width={"50%"}
            onClick={onCancel}
          />
          <CustomDeleteButton
            title="Yes"
            isRound
            width={"50%"}
            onClick={onYes}
          />
        </div>
      </div>

      <div className="absolute -left-3 top-[20px]">
        <img src={dentalIcons.shapeArrow} alt="shape" />
      </div>
    </div>
  );
};

export default FlipImageWarming;
